<!--
  EntityInputLocation.vue — the `entity-input-location` widget. Binds a
  { address, lat, lng, radius } object; radius defaults to 150 (matching the
  employee itemCfg fetch decorator). A real deployment wires the address field
  to a geocoder + map picker (Leaflet engine); this captures the model contract.

  Reconstructed from lacak.io deployed behavior; app-specific contract verbatim
  (props value/field/rules/disabled/label; emits `input` a location object with
  lat/lng/address/radius; default radius 150), internal impl re-authored on
  Vuetify 1.5 controls.
-->
<template>
  <v-container class="pa-0" grid-list-md>
    <v-layout row wrap>
      <v-flex xs12>
        <v-text-field
          :value="model.address"
          :label="resolvedLabel"
          :rules="rules"
          :disabled="disabled"
          prepend-icon="location_on"
          @input="update('address', $event)"
        />
      </v-flex>
      <v-flex xs4>
        <v-text-field
          :value="model.lat"
          label="Lat"
          type="number"
          :disabled="disabled"
          @input="update('lat', toNum($event))"
        />
      </v-flex>
      <v-flex xs4>
        <v-text-field
          :value="model.lng"
          label="Lng"
          type="number"
          :disabled="disabled"
          @input="update('lng', toNum($event))"
        />
      </v-flex>
      <v-flex xs4>
        <v-text-field
          :value="model.radius"
          label="Radius, m"
          type="number"
          :disabled="disabled"
          @input="update('radius', toNum($event))"
        />
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  name: 'entity-input-location',
  props: {
    value: { default: null },
    field: { type: Object, default: () => ({}) },
    rules: { type: Array, default: () => [] },
    disabled: { type: Boolean, default: false },
    label: { type: String, default: '' },
  },
  computed: {
    resolvedLabel() { return this.label || (this.field && this.field.label) || ''; },
    model() {
      const v = this.value || {};
      return { address: v.address || '', lat: v.lat != null ? v.lat : null, lng: v.lng != null ? v.lng : null, radius: v.radius != null ? v.radius : 150 };
    },
  },
  methods: {
    toNum(val) { if (val === '' || val == null) return null; const n = Number(val); return Number.isNaN(n) ? null : n; },
    update(key, val) {
      const next = Object.assign({}, this.model, { [key]: val });
      // emit null when the whole location is empty
      const empty = !next.address && next.lat == null && next.lng == null;
      this.$emit('input', empty ? null : next);
    },
  },
};
</script>
